// eslint-disable-next-line @tseslint/typedef
export const PROJECT_ROUTES_PARAMS = {
  number: "projectNumber"
};
